import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../App";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CourseCard from "../components/CourseCard";
import { Button } from "../components/ui/button";
import { ChevronLeft, ChevronRight, Play } from "lucide-react";
import PromotionCard from "../components/PromotionCard";

const Home = () => {
  const { API } = useAuth();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const response = await axios.get(`${API}/courses`);
      setCourses(response.data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    } finally {
      setLoading(false);
    }
  };

  const getCoursesByCategory = (category) => {
    return courses.filter((c) => c.category === category);
  };

  const getRecentCourses = () => {
    return courses.slice(0, 6);
  };

  const CourseCarousel = ({ title, courses }) => {
    const scrollLeft = () => {
      document.getElementById(`carousel-${title}`).scrollBy({ left: -300, behavior: "smooth" });
    };

    const scrollRight = () => {
      document.getElementById(`carousel-${title}`).scrollBy({ left: 300, behavior: "smooth" });
    };

    if (courses.length === 0) return null;

    return (
      <div className="mb-12">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">{title}</h2>
        <div className="relative group">
          <button
            onClick={scrollLeft}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-black/60 hover:bg-black/80 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
            data-testid={`carousel-left-${title}`}
          >
            <ChevronLeft className="w-6 h-6 text-white" />
          </button>
          <div
            id={`carousel-${title}`}
            className="flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {courses.map((course) => (
              <div key={course.id} className="flex-none w-[280px] md:w-[320px]">
                <CourseCard course={course} />
              </div>
            ))}
          </div>
          <button
            onClick={scrollRight}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-black/60 hover:bg-black/80 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
            data-testid={`carousel-right-${title}`}
          >
            <ChevronRight className="w-6 h-6 text-white" />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-black">
      <Header />

      {/* Hero Section */}
      <section className="relative h-[70vh] md:h-[80vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1734336009361-f8d43327430f?crop=entropy&cs=srgb&fm=jpg&q=85"
            alt="Hero"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-black tracking-tighter text-white mb-4 leading-tight animate-fade-in">
            De emprendedor a empresario.
          </h1>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#E50914] mb-6">
            Metodología práctica, casos reales y herramientas listas para que tu emprendimiento opere como una empresa profesional.
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/cursos">
              <Button
                size="lg"
                variant="outline"
                className="bg-white/10 backdrop-blur-sm text-white hover:bg-white/20 transition-all duration-300 font-medium px-8 py-6 text-lg border border-white/10"
                data-testid="hero-ver-cursos-btn"
              >
                <Play className="w-5 h-5 mr-2 fill-white" />
                Ver Cursos
              </Button>
            </Link>
            <Link to="/contaflix-pro">
              <Button
                size="lg"
                className="bg-[#E50914] hover:bg-[#E50914]/90 text-white shadow-[0_0_20px_rgba(229,9,20,0.4)] hover:shadow-[0_0_30px_rgba(229,9,20,0.6)] transition-all duration-300 font-semibold px-8 py-6 text-lg"
                data-testid="hero-pro-btn"
              >
                Probar ContaFLIX PRO
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Course Carousels */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-20">
        <div className="mb-10">
          <PromotionCard />
        </div>
        {loading ? (
          <div className="text-center text-white py-20">Cargando cursos...</div>
        ) : (
          <>
            <CourseCarousel title="Nuevos" courses={getRecentCourses()} />
            <CourseCarousel title="Contabilidad" courses={getCoursesByCategory("Contabilidad")} />
            <CourseCarousel title="Tributación" courses={getCoursesByCategory("Tributación")} />
            <CourseCarousel title="Laboral" courses={getCoursesByCategory("Laboral")} />
            <CourseCarousel title="Finanzas" courses={getCoursesByCategory("Finanzas")} />
          </>
        )}
      </section>

      <Footer />
    </div>
  );
};

export default Home;
